import * as React from "react";
import Box from "@mui/material/Box";
import { LTLState } from "@taskpane/hooks/useLTLReducer";
import { itemsEditorStyles as styles } from "./itemsEditor.styles";
import { LtlFreightItemHazmatCheckbox } from "./LtlFreightItemHazmatCheckbox";
import { LtlFreightItemLwhStack } from "./LtlFreightItemLwhStack";

type ItemRow = LTLState["items"][number];

interface LtlFreightItemDimensionsHazmatProps {
  item: ItemRow;
  index: number;
  state: LTLState;
  onItemFieldChange: (index: number, field: keyof ItemRow, value: unknown) => void;
  onFieldBlur?: () => void;
  getTextFieldStyles: (fieldKey: string) => unknown;
}

export function LtlFreightItemDimensionsHazmat({
  item,
  index,
  state,
  onItemFieldChange,
  onFieldBlur,
  getTextFieldStyles,
}: LtlFreightItemDimensionsHazmatProps): React.ReactElement {
  return (
    <Box sx={styles.row}>
      <LtlFreightItemLwhStack
        item={item}
        index={index}
        state={state}
        onItemFieldChange={onItemFieldChange}
        onFieldBlur={onFieldBlur}
        getTextFieldStyles={getTextFieldStyles}
      />
      <LtlFreightItemHazmatCheckbox
        item={item}
        index={index}
        onItemFieldChange={onItemFieldChange}
        onFieldBlur={onFieldBlur}
      />
    </Box>
  );
}
